import './index.css'

import React, { useEffect, useRef } from 'react'
import Modal from 'react-modal'
import { downloadInFrameIfSupported } from '@disco/utils/target-iframe'
import modalStyles from 'components/utils/modalStyles'
type Props = {
  type: 'base' | 'loading' | 'error' | 'deferred'
  onClose: (...args: Array<any>) => any
  onClick?: (...args: Array<any>) => any
  url?: string | null | undefined
}

const DownloadModal = (props: Props): React.ReactNode => {
  const ref = useRef<HTMLAnchorElement>(null)
  useEffect(() => {
    if (props.url && ref.current) {
      ref.current.click()
    }
  }, [props.url])

  const renderDownload = () => {
    switch (props.type) {
      case 'base':
        return (
          <div className="DownloadModal_Link">
            <i className="Icon download" />
            Your download should start very shortly.
            <br />
            If your file doesn’t start downloading
            within&nbsp;a&nbsp;minute&nbsp;or&nbsp;two,{' '}
            <a
              ref={ref}
              className="DownloadModal_Link DownloadModal_Text is-link"
              download
              href={props.url}
              target={downloadInFrameIfSupported()}
              onClick={props.onClick}
            >
              click&nbsp;here
            </a>
            .
          </div>
        )

      case 'error':
        return (
          <button className="DownloadModal_Link" onClick={props.onClick}>
            <i className="Icon error" />
            <div className="Download_Text is-error">Error, click to retry</div>
          </button>
        )

      case 'loading':
        return (
          <div className="DownloadModal_Link">
            <i className="Icon loading" />
            <div className="Download_Text ">Generating Download</div>
          </div>
        )

      case 'deferred':
        return (
          <div className="DownloadModal_Link">
            <div className="Download_Text ">
              We’re generating your export now, and will email it to you as soon
              as it’s ready. Please note, during peak periods, reports can take
              up to an hour to generate.
            </div>
          </div>
        )

      default:
        break
    }
  }

  return (
    <Modal onRequestClose={props.onClose} isOpen style={modalStyles}>
      <div className="DownloadModal" onClick={e => e.stopPropagation()}>
        {renderDownload()}
      </div>
    </Modal>
  )
}

export default DownloadModal
